import type * as Types from '../base-types.graphql';

import { gql } from '@apollo/client';
import { ValidatorStatusFieldsFragmentDoc } from './validator-status.graphql';
export type GqlSiValidatorErrorFieldsFragment = { decision: { completed: boolean, hasError: boolean, severity: Types.GqlSeverity, error?: { sv: { short?: string | null, long?: string | null }, en: { short?: string | null, long?: string | null } } | null }, newShares: { completed: boolean, hasError: boolean, severity: Types.GqlSeverity, error?: { sv: { short?: string | null, long?: string | null }, en: { short?: string | null, long?: string | null } } | null }, shareClasses: { completed: boolean, hasError: boolean, severity: Types.GqlSeverity, error?: { sv: { short?: string | null, long?: string | null }, en: { short?: string | null, long?: string | null } } | null }, preferentialRights: { completed: boolean, hasError: boolean, severity: Types.GqlSeverity, error?: { sv: { short?: string | null, long?: string | null }, en: { short?: string | null, long?: string | null } } | null }, subscriptionDate: { completed: boolean, hasError: boolean, severity: Types.GqlSeverity, error?: { sv: { short?: string | null, long?: string | null }, en: { short?: string | null, long?: string | null } } | null }, payByOffset: { completed: boolean, hasError: boolean, severity: Types.GqlSeverity, error?: { sv: { short?: string | null, long?: string | null }, en: { short?: string | null, long?: string | null } } | null }, nonCash: { completed: boolean, hasError: boolean, severity: Types.GqlSeverity, error?: { sv: { short?: string | null, long?: string | null }, en: { short?: string | null, long?: string | null } } | null }, language: { completed: boolean, hasError: boolean, severity: Types.GqlSeverity, error?: { sv: { short?: string | null, long?: string | null }, en: { short?: string | null, long?: string | null } } | null }, boardsStatement: { completed: boolean, hasError: boolean, severity: Types.GqlSeverity, error?: { sv: { short?: string | null, long?: string | null }, en: { short?: string | null, long?: string | null } } | null }, paymentKind: { completed: boolean, hasError: boolean, severity: Types.GqlSeverity, error?: { sv: { short?: string | null, long?: string | null }, en: { short?: string | null, long?: string | null } } | null } };

export const SiValidatorErrorFieldsFragmentDoc = gql`
    fragment SiValidatorErrorFields on ShareIssueValidatorErrors {
  decision {
    ...ValidatorStatusFields
  }
  newShares {
    ...ValidatorStatusFields
  }
  shareClasses {
    ...ValidatorStatusFields
  }
  preferentialRights {
    ...ValidatorStatusFields
  }
  subscriptionDate {
    ...ValidatorStatusFields
  }
  payByOffset {
    ...ValidatorStatusFields
  }
  nonCash {
    ...ValidatorStatusFields
  }
  language {
    ...ValidatorStatusFields
  }
  boardsStatement {
    ...ValidatorStatusFields
  }
  paymentKind {
    ...ValidatorStatusFields
  }
}
    ${ValidatorStatusFieldsFragmentDoc}`;